import { BaseEntityActions } from '../..';

export class OutputActionEventArgs {
    AcceptPayload: boolean;
    Type: BaseEntityActions;
}
